import React  from "react";
import styled from "styled-components";
import {useNavigate} from "react-router-dom";
import spriteImage from "../../assets/images/sprite.png";
import tabImage1 from "../../assets/images/m_info1.jpg";
import tabImage2 from "../../assets/images/m_info2.jpg";
import tabImage3 from "../../assets/images/m_info3.jpg";
import tabImage4 from "../../assets/images/m_info4.jpg";
import {device} from "../../assets/styles/media";
import decodeEntities from "../../util/decodeEntities";

const ContentsInner = styled.div`
    margin: 0 auto;
    padding: 15px 60px 50px 60px;

    ${device.mobile} {
        padding: 10px 20px 20px 20px;
    }
`;
const ContentsItem = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    height: ${(props) => (props.active ? "930px" : "300px")};
    margin-bottom: 20px;

    ul {
        display: block;
        opacity: ${(props) => (props.active ? 1 : 0)};
        max-height: ${(props) => (props.active ? "930px" : "0")};
        transition: opacity 0.3s ease, max-height 0.3s ease;
    }
    ${device.mobile} {
        margin-bottom: 0;
        height: ${(props) => (props.active ? "520px" : "150px")};
        ul {
            max-height: ${(props) => (props.active ? "400px" : "0")};
        }
    }

`;
const TitleTxt = styled.strong`
    position: relative;
    color: #fff;
    font-size: 2rem;
    font-weight: 500;
    letter-spacing: 2rem;

    ${device.mobile} {
        font-size: 16px;
        letter-spacing: 0.8rem;
    }
`;
const Arrow = styled.span`
    &::after {
        content: "";
        position: absolute;
        top: 5px;
        right: -0.5rem;
        width: 24px;
        height: 24px;
        background-image: url(${spriteImage});
        background-size: 418px, 402px;
        background-position: -378px -218px;
    }

    ${device.mobile} {
        &::after {
            transform: scale(0.6);
            top: -2.5px;
            right: -10px;
        }
    }
`;
const ContentTitle = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    height: 300px;
    align-items: center;
    cursor: pointer;
    border-radius: 10px;
    padding-top: 20px;
    background-size: cover;
    background-image: url(${({$bgImage}) => {
        switch ($bgImage) {
            case 1:
                return tabImage1;
            case 2:
                return tabImage2;
            case 3:
                return tabImage3;
            case 4:
                return tabImage4;
            default:
                return tabImage1;
        }
    }});


    ${device.mobile} {
        height: 150px;
        padding-top: 0;
        margin-top: 15px;

        &::after {
            height: 100%;
        }
    }
`;
const ContentList = styled.ul`
    position: absolute;
    top: 300px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    justify-content: center;
    padding: 20px;
    width: 100%;
    ${device.mobile} {
        top: 170px;
        padding: 0 20px;
        opacity: ${(props) => (props.active ? 1 : 0)};
        max-height: ${(props) => (props.active ? "400px" : "0")};
    }
`;
const Item = styled.li`
    padding: 20px 0;
    border-bottom: ${({$isLast}) => ($isLast ? "none" : "2px solid #c6c6c6")};

    ${device.mobile} {
        border-bottom: ${({$isLast}) => ($isLast ? "none" : "1px solid #c6c6c6")};
    }
`;

const Link = styled.a``;
const Kind = styled.span`
    color: #362579;
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 55px;

    ${device.mobile} {
        font-size: 13px;
        line-height: 25px;
    }
`;
const ListTitle = styled.strong`
    display: block;
    padding-top: 7px;
    font-size: 1.8rem;
    color: #3b3b3b;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${device.mobile} {
        font-size: 14px;
        font-weight: 600;
    }
`;
const ListDesc = styled.p`
    padding-top: 12px;
    color: #3b3b3b;
    font-size: 1.5rem;
    line-height: 45px;
    font-weight: 400;
    letter-spacing: -0.3px;
    display: -webkit-box;
    overflow: hidden;
    word-wrap: break-word;
    text-overflow: ellipsis;

    ${device.mobile} {
        line-height: 18px;
        font-size: 13px;
        letter-spacing: -0.5px;
        padding-top: 5px;
    }
`;
const TabHomeContents = ({list}) => {
    const navigate = useNavigate();
    return (
        <ContentsInner>
            {list?.map((item, index) => {
                return (
                    <ContentsItem
                        key={item.title}
                        active={0 === index}
                    >
                        <ContentTitle
                            $bgImage={index + 1}
                            active={0 === index}
                            onClick={() => navigate(item.link)}
                        >
                            <TitleTxt>
                                {item.title}
                                <Arrow/>
                            </TitleTxt>
                        </ContentTitle>
                        {index === 0 ?
                            <ContentList>
                                {item.subList.map((subItem, subIndex) => (
                                    <Item
                                        key={subItem.postId}
                                        active={subIndex === 0}
                                        $isLast={subIndex === item.subList.length - 1}
                                    >
                                        <Link
                                            onClick={() => navigate(subItem.apiUrl)}
                                        >
                                            <Kind>{subItem.category}</Kind>
                                            <ListTitle>{decodeEntities(subItem.subject)}</ListTitle>
                                            <ListDesc>{decodeEntities(subItem.descLine)}</ListDesc>
                                        </Link>
                                    </Item>
                                ))}
                            </ContentList> :""}
                    </ContentsItem>
                );
            })}
        </ContentsInner>
    );
};

export default TabHomeContents;
